import 'modernizr'; // eslint-disable-line
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import '../vendor/bootstrap';

import tracking from '../modules/tracking';
import header from '../modules/header';
import navigation from '../modules/navigation';
import search from '../modules/search';
import coreBusiness from '../modules/coreBusiness';
import toTop from '../modules/toTop';
import videoOverlay from '../modules/videoOverlay';
import slider from '../modules/slider';
import homeSlider from '../modules/homeSlider';
import recyclingSlider from '../modules/recyclingSlider';
import toggle from '../modules/toggle';
import jumpToElement from '../modules/jumpToElement';
import datepicker from '../modules/datepicker';
import cookieBar from '../modules/cookieBar';
import embedWrap from '../modules/embedWrap';
import whatsapp from '../modules/whatsapp';
import alert from '../modules/alert';
import accessibility from '../modules/accessibility';
import mediaRow from '../modules/mediaRow';
import controlledInput from '../modules/controlledInput';
import print from '../modules/print';
// import gaTracking from '../modules/gaTracking';

const general = () => {
  tracking.initialize();
  accessibility.initialize();
  header.initialize();
  navigation.initialize();
  search.initialize();
  coreBusiness.initialize();
  toTop.initialize();
  videoOverlay.initialize();
  slider.initialize();
  homeSlider.initialize();
  recyclingSlider.initialize();
  toggle.initialize();
  jumpToElement.initialize();
  datepicker.initialize();
  cookieBar.initialize();
  embedWrap();
  whatsapp.initialize();
  alert.initialize();
  mediaRow.initialize();
  controlledInput.initialize();
  print.initialize();
  // gaTracking();
  porta({
    messages: nl,
  });
};

export default general;
